// extracted by mini-css-extract-plugin
export var actionButton = "_e5-0";
export var attachmentLine = "_e5-1";
export var fileInput = "_e5-2";
export var fileUploadWrapper = "_e5-4";
export var footer = "_e5-3";
export var modalContent = "_e5-5";
export var paperclip = "_e5-6";
export var quillEditor = "_e5-7";